//import { createSelector } from 'reselect';
import { selectedAddress } from './ServiceAddress';
import * as consts from '../constants';
import util from '../lib/util';

// CustomerType has three options of Residential, Commercial and Builder
const selectloggedInbupaNumber = (state) => {
    if (state.gas.user && state.gas.user.isBpAuthenticated)
        return state.gas.user.bpNumber;
    else
        return null;
};
const selectfortisBCAccountAccountNumber = () => (state) => state.form.fortisBCAccount_accountNumber;
const selectBupaVerifyErrorMsg = () => (state) => state.gas.bupaVerifyErrorMsg;
const selectProvidedIdentificationId = () => (state) => (state.form.providedIdentificationId);
const selectIdentificationVerificationInput = () => (state) => (state.form.identificationVerificationInput);
// Residentail customer
const selectResidentAddress = () => (state) => (state.session && state.session.ResidentAddress);
const selectExisitngFortisBCCustomer = () => (state) => state.form.fortisBCAccount;
const selectBupaChecked = () => (state) => state.gas.bupaChecked;
const selectForm = () => (state) => state.form;
const selectAccountNo = () => (state) => state.form.accountNumber;
const selectBupaVerified = () => (state) => state.form.bupaVerified;
const selectVerifyAccountRetries = () => (state) => state.gas.verifyAccountRetries;
const selectBupaVerifyRetrieErrorMsg = () => (state) => state.gas.bupaVerifyRetrieErrorMsg;
const selectBillingAddressModel = (state, name) => {
    const bupaModel = state.form;
    let address = null;
    switch (bupaModel[name]) {
        case "1": // Same as service address
            address = selectedAddress(state);
            break;
        case "2": // PO Box
            address = {
                isPoBox: true,
                city: bupaModel[`${name}_poBox_city`],
                province: bupaModel[`${name}_poBox_state`],
                postCode: bupaModel[`${name}_poBox_postalCode`],
                poBox: bupaModel[`${name}_poBox_poBox`],
                country: bupaModel[`${name}_poBox_country`]
            };
            break;
        case "3": // Different address
            address = {
                isPoBox: false,
                unitNumber: bupaModel[`${name}_address_unitNumber`] ? bupaModel[`${name}_address_unitNumber`] : '',
                streetNumber: bupaModel[`${name}_address_streetNumber`],
                streetName: bupaModel[`${name}_address_streetName`],
                streetType: bupaModel[`${name}_address_streetType`] ? bupaModel[`${name}_address_streetType`] : '',
                streetDirection: bupaModel[`${name}_address_streetDirection`] ? bupaModel[`${name}_address_streetDirection`] :'',
                city: bupaModel[`${name}_address_city`],
                province: bupaModel[`${name}_address_state`],
                postCode: bupaModel[`${name}_address_zip`],
                poBox: '',
                country: bupaModel[`${name}_address_country`]
            };
            break;
    }
    return address;
};
const selectIdTypeModel = (state) => {
    let identifications = null;
    const f = state.form;
    // Residential
    if (f.customerType == "1") {
        switch (f.idType) {
            case "1":
                identifications = { Type: "DL", Value: f.idType_DriverLicence };
                break;
            case "2":
                identifications = { Type: "BCID", Value: f.idType_BCIdentification };
                break;
            case "3":
                identifications = { Type: "PN", Value: f.idType_PassportNo };
                break;
        }
    }
    // Commercial
    else if (f.customerType == "2" || f.customerType == "3") {
        identifications = { Type: "SIN/BN", Value: f.idType_BusinessNumber };
    }
    return identifications;
};

const selectBusinessPartnerModel = (state) => {
    // Business Partner Model
    const form = state.form;
    let dob = new String(form.accountHolderInfo_residentInfo_dob);
    if (form.accountHolderInfo_residentInfo_dob)
        dob = util.DobFormatter(dob);
    else
        dob = null;
    let BillingMethod = form.billingMethod;
    if (state.gas.productName === consts.SERVICE_REMOVAL_NAME)//For service removal, billing method should be always empty
        BillingMethod = "";
    //TODO: validate the data
    const model = {
        BpNumber: (state.gas.user && state.gas.user.bpNumber),
        BaNumber: state.gas.baNumber,
        // TODO: Add IsResidential (check whether it has declared)
        IsBusiness: (form.customerType == "2" || form.customerType == "3"),
        IsBuilder: (form.customerType == "3"),
        IsCommercial: false,  // What is IsCommercial and why it is always false?
        //BillingMethod: form.billingMethod,
        BillingMethod,
        // Business partner phone info
        PrimaryPhone: form.accountHolderInfo_phoneContact_primaryPhone,
        PrimaryPhoneExt: form.accountHolderInfo_phoneContact_primaryPhone_ext,
        SecondaryPhone: form.accountHolderInfo_phoneContact_secondaryPhone,
        SecondaryPhoneExt: form.accountHolderInfo_phoneContact_secondaryPhone_ext,
        PrimaryCellPhone: form.accountHolderInfo_phoneContact_primaryCellPhone,
        PrimaryCellPhoneExt: form.accountHolderInfo_phoneContact_primaryCellPhone_ext,
        SecondaryCellPhone: form.accountHolderInfo_phoneContact_secondaryCellPhone,
        SecondaryCellPhoneExt: form.accountHolderInfo_phoneContact_secondaryCellPhone_ext,
        // For Residential, Busienss partner name, DOB and email are required in UI
        FirstName: form.accountHolderInfo_residentInfo_firstName,
        LastName: form.accountHolderInfo_residentInfo_lastName,
        DOB: dob,
        Email: form.emailAddress,
        // Email address for notifications
        ProjectEmail: (form.projectNotificationsEmail_IsSame == 1) ?
            "" : (form.projectNotificationsEmail ? form.projectNotificationsEmail : ""),
        // For commercial, Business Name is required in UI
        BusinessName: form.accountHolderInfo_businessInfo_businessName,
        IsAccountSkipped : false,
        FoundBPs : []
        // FortisBC account identification
        //Identifications: [idTypeModel],
        // HasContractInLastTwoYears:,
        // SentToCollectionAgency:,
        // IsCreditCheckRequired:,
    };
    return model;
};

const selectBusinessAgreementModel = (state) => {
    const form = state.form;
    return {
        BillingMethod: form.billingMethod,
        BpNumber: (state.gas.user && state.gas.user.bpNumber),
        IsBusiness: (form.customerType == 2 || form.customerType == 3),
        IsBuilder: (form.customerType == 3),
        IsCommercial: false,  // What is IsCommercial and why it is always false?
        ObjectId: null //should filled after updateBupa called and return objectId to use for calling createBuag(Business Agreement)
    };
};
export {
    // Customer type
    selectExisitngFortisBCCustomer,
    selectBillingAddressModel,
    selectIdTypeModel,
    selectBusinessPartnerModel,
    selectBusinessAgreementModel,
    selectloggedInbupaNumber,
    selectfortisBCAccountAccountNumber,
    selectBupaVerifyErrorMsg,
    selectProvidedIdentificationId,
    selectIdentificationVerificationInput,
    // Residentail
    selectResidentAddress,
    selectBupaChecked,
    selectBupaVerified,
    selectVerifyAccountRetries,
    selectBupaVerifyRetrieErrorMsg,
    selectForm,
    selectAccountNo
};